import React, { useState, useEffect, useRef } from 'react'
import {
    Box, Tooltip, TextField
} from "@mui/material";
import PricingCopyMenu from './PricingCopyMenu'

const MinInput = ({ day, season, seasonEditCopyRef, isReadOnlyMode, manageSeasonChangeFunc, discardCount, globalErrorMsg, disableDownCopy, disableRightCopy, copyInputCount, registerRef, onNavigate }) => {
    const { threshold_min, threshold_max } = seasonEditCopyRef.current.base_room_type;

    const inputRef = useRef(null);
    const [inputErrorMsg, setInputErrorMsg] = useState(false);

    const [isBaseRoomTypeChanged, setIsBaseRoomTypeChanged] = useState(season.isBaseRoomTypeChanged);

    const handleInputBlur = (event) => {
        let min = event.target.value.trim();
        let max = threshold_max[day];

        // remove decimal if any
        if (min.includes('.')) {
            min = min.split('.')[0];
            event.target.value = min;
        }


        // if min has negative sign then remove it
        if (min.includes('-')) {
            min = 0;
            min = Number(min);
            event.target.value = min;
            seasonEditCopyRef.current.base_room_type.threshold_min[day] = min;
            manageSeasonChangeFunc({ action: 'inputChange', season: seasonEditCopyRef.current });
            return;
        }

        // if min is blank
        if (min === '') {
            setInputErrorMsg('This field is required.');
            seasonEditCopyRef.current.base_room_type.threshold_min[day] = null;
            manageSeasonChangeFunc({ action: 'inputChange', season: seasonEditCopyRef.current });
            return;
        }
        setIsBaseRoomTypeChanged(false);

        // if max is blank then min can be any positive number
        if (!max && max !== 0) {
            min = Number(min);
            setInputErrorMsg(false);
            seasonEditCopyRef.current.base_room_type.threshold_min[day] = min;
            manageSeasonChangeFunc({ action: 'inputChange', season: seasonEditCopyRef.current });
            return;
        }

        // if min is greater than max
        min = Number(min);
        max = Number(max);
        if (min > max) {
            setInputErrorMsg('Floor cannot be greater than ceiling.');
            seasonEditCopyRef.current.base_room_type.threshold_min[day] = min;
            manageSeasonChangeFunc({ action: 'inputChange', season: seasonEditCopyRef.current });
            return;
        }

        setInputErrorMsg(false);
        seasonEditCopyRef.current.base_room_type.threshold_min[day] = min;
        manageSeasonChangeFunc({ action: 'inputChange', season: seasonEditCopyRef.current });

    }

    const handleCopyRight = () => {
        const currentValue = seasonEditCopyRef.current.base_room_type.threshold_min[day];
        const dayKeys = Object.keys(seasonEditCopyRef.current.base_room_type.threshold_min);
        const currentIndex = dayKeys.indexOf(day);
        if (currentIndex === -1) return;

        // Copy value to the right-side inputs
        for (let i = currentIndex + 1; i < dayKeys.length; i++) {
            const nextDay = dayKeys[i];
            seasonEditCopyRef.current.base_room_type.threshold_min[nextDay] = currentValue;

            // If copied min is grater than its max, replace with max instead
            // const maxValue = seasonEditCopyRef.current.base_room_type.threshold_max[nextDay];
            // if (maxValue !== null && maxValue !== undefined && currentValue > maxValue) {
            //     seasonEditCopyRef.current.base_room_type.threshold_min[nextDay] = maxValue;
            // } else {
            //     seasonEditCopyRef.current.base_room_type.threshold_min[nextDay] = currentValue;
            // }
        }

        manageSeasonChangeFunc({
            action: 'copyInput',
            season: seasonEditCopyRef.current
        });
        setIsBaseRoomTypeChanged(false);
        //console.log("seasonEditCopyRef.current", seasonEditCopyRef.current)
    };

    // Register on every render (IMPORTANT)
    registerRef("min", day, inputRef);

    useEffect(() => {
        setInputErrorMsg(false);
        inputRef.current.value = season.base_room_type.threshold_min[day];
    }, [discardCount])


    useEffect(() => {
        if (seasonEditCopyRef.current.base_room_type.threshold_max[day] && seasonEditCopyRef.current.base_room_type.threshold_min[day]) {
            let min = seasonEditCopyRef.current.base_room_type.threshold_min[day];
            let max = seasonEditCopyRef.current.base_room_type.threshold_max[day];
            if (min > max) {
                setInputErrorMsg('Floor cannot be greater than ceiling.');
            }
            else {
                setInputErrorMsg(false);
            }
        }
    }, [globalErrorMsg.length]);


    useEffect(() => {
        inputRef.current.value = seasonEditCopyRef.current.base_room_type.threshold_min[day];

        // If min is valid (not null), clear the "required" error
        const minValue = seasonEditCopyRef.current.base_room_type.threshold_min[day];
        const maxValue = seasonEditCopyRef.current.base_room_type.threshold_max[day];

        if (minValue !== null && minValue !== '') {
            setInputErrorMsg(false);
            setIsBaseRoomTypeChanged(false);

        }

        // If both exist, revalidate relationship
        if (minValue !== null && maxValue !== null) {
            if (Number(minValue) > Number(maxValue)) {
                setInputErrorMsg("Floor cannot be greater than ceiling.");
            } else {
                setInputErrorMsg(false);
            }
        }


    }, [copyInputCount]);


    const handleArrowKeyNavigation = (e) => {
        const navKeys = ["ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown"];
        if (!navKeys.includes(e.key)) return;

        e.preventDefault();
        const direction = e.key.replace("Arrow", "").toLowerCase();
        onNavigate(direction, day, "min");
    };



    return (
        <Box className="grid-col" >
            <Tooltip
                arrow
                title={inputErrorMsg}
                placement="top"
                slotProps={{
                    tooltip: {
                        sx: {
                            maxWidth: 350,
                        },
                    },
                }}
            >
                <TextField
                    type="number"
                    inputRef={inputRef}
                    // className={`custon-textfield ${inputErrorMsg ? 'error' : ''}`}
                    className={`custon-textfield 
                        ${inputErrorMsg ? 'error' : ''}
                        ${threshold_min[day] === null && !season.id.includes('new_') ? 'empty_field' : ''} 
                    `}
                    size="small"
                    fullWidth
                    margin="dense"
                    disabled={isReadOnlyMode}
                    defaultValue={threshold_min[day]}
                    onFocus={(e) =>  e.target.select()}
                    onBlur={(event) => { handleInputBlur(event) }}
                    onKeyDown={handleArrowKeyNavigation}
                    autoComplete="off"
                />
                {!isReadOnlyMode && threshold_min[day] !== null && threshold_min[day] !== undefined && (
                    <PricingCopyMenu
                        disableDownCopy={disableDownCopy}
                        disableRightCopy={disableRightCopy}
                        onCopyRight={handleCopyRight}
                    />
                )}
            </Tooltip>
        </Box>
    )
}

export default MinInput